// extracted by mini-css-extract-plugin
module.exports = {"trails":"trails_trails__3eBRE"};